var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("It is working.")]),_c('v-btn',{staticClass:"secondary",attrs:{"block":"","x-large":""},on:{"click":_vm.APIConnectionCheck}},[_vm._v("API health check")]),_c('h2',[_vm._v(_vm._s(_vm.message))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }